import { Component } from "@angular/core";

@Component({
  selector: "app-connect-via-gar",
  templateUrl: "./connect-via-gar.component.html",
})
export class ConnectViaGarComponent {}
